/* eslint-disable */
import axios from "axios";
import history from "../router/history";
import { signIn } from "../router/routes";
import { toast } from "react-toastify";
import changeDataKeys, { camelToSnake, snakeToCamel } from "../helpers/data";

const HTTP_STATUS = {
  UNAUTHORIZED: 401,
  BAD_REQUEST: 400,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  SERVER_ERROR: 500
};

export const http = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
    "X-CSRFToken":
      "cbxeEDzOz9RoYf7Mp2MXKZ5JEhna4xkj7DP6mRvuNgfiEkhWgfVab7SwGb88OJC4"
  }
});

http.interceptors.request.use(
  async config => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers = { ...config.headers, Authorization: `Token ${token}` };
    }
    if (config.data && config.headers["Content-Type"] === "application/json") {
      config.data = changeDataKeys(config.data, camelToSnake);
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  async response => {
    if (response.headers["content-type"] === "application/json") {
      response.data = changeDataKeys(response.data, snakeToCamel);
    }

    return response;
  },
  async error => {
    const { response } = error;
    if (response.status === HTTP_STATUS.UNAUTHORIZED) {
      localStorage.clear();
      history.push(signIn);
    }

    if (response.status >= HTTP_STATUS.SERVER_ERROR) {
      // TODO make an errors action handler
      // alert(
      //   `Something went wrong cause of the error:\r\n Status code: ${error.response.status} ${JSON.stringify(error.response.data)}`
      // );
      console.log(
        "Something went wrong cause of next error: ",
        error.response,
        "\n",
        error.config
      );
    }
    if (response.status === HTTP_STATUS.FORBIDDEN) {
      // const test = NotificationManager.error(response.data.detail, "Attention", 3000);
      toast.error(response.data.detail, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
      });
    }
    if (response && response.data) {
      error.response.data = changeDataKeys(response.data, snakeToCamel);
    }
    return Promise.reject(error);
  }
);
